const ENVIRONMENT_KEY = 'ENVIRONMENT';
const API_V4_HOSTNAME_KEY = 'API_V4_HOSTNAME';
const API_V1_HOSTNAME_KEY = 'API_V1_HOSTNAME';
const API_V2_HOSTNAME_KEY = 'API_V2_HOSTNAME';
const STATUS_PAGE_LINK_KEY = 'STATUS_PAGE_LINK';
const MANAGE_ACCOUNT_LINK_KEY = 'MANAGE_ACCOUNT_LINK';
const REACT_APP_SSO_KEY = 'REACT_APP_SSO';
const REACT_APP_LINK_SUPPORT_KEY = 'REACT_APP_LINK_SUPPORT';
const BACK_OFFICE_LINK_KEY = 'BACK_OFFICE_LINK';

export {
  ENVIRONMENT_KEY,
  API_V4_HOSTNAME_KEY,
  API_V1_HOSTNAME_KEY,
  API_V2_HOSTNAME_KEY,
  STATUS_PAGE_LINK_KEY,
  MANAGE_ACCOUNT_LINK_KEY,
  REACT_APP_SSO_KEY,
  REACT_APP_LINK_SUPPORT_KEY,
  BACK_OFFICE_LINK_KEY,
};
